const getAvailableEndorsementsState = (state: ReduxState) => state.availableEndorsements || {};

export const getIsAvailableEndorsementsLoading = (state: ReduxState) => getAvailableEndorsementsState(state).isLoading;
export const getAvailableEndorsements = (state: ReduxState) => getAvailableEndorsementsState(state).endorsements;
export const getAvailableEndorsementsOptions = (state: ReduxState) => getAvailableEndorsementsState(state).options;
